var codeSnippetFunc = (function() {
  return {
    init: init,
    onClickCTAEvent: onClickCTAEvent
  };

  //init function
  function init() {
    getParentsElem();
    uiBindings();
  }

  function uiBindings() {
    /*
     * Prettyprint add copy button for guide pages
     * Event added of copy button : mousedown, mouseup
     * User selection copy button click event
     */
    var pre = document.querySelectorAll("pre.prettyprint");
    for (var i = 0; i < pre.length; i++) {
      var element = pre[i];

      // `element` is the element you want to wrap
      var parent = element.parentNode;
      var wrapper = document.createElement("div");
      wrapper.className = "prettyprint__wrapper";

      // set the wrapper as child (instead of the element)
      parent.replaceChild(wrapper, element);
      // set element as child of wrapper
      wrapper.appendChild(element);

      var button = document.createElement("button");
      button.className = "copy-clipboard__btn copy-clipboard__window";
      var s = pre[i].innerText;

      //tabindex require for the keyboard event div element
      if (null == element.getAttribute("tabindex")) {
        var tabIndex = document.createAttribute("tabindex");
        tabIndex.value = "0";
        element.setAttributeNode(tabIndex);
      }

      var popover = document.createElement("div");
      popover.className = "copy-clipboard__popover copy-clipboard__window";
      popover.innerHTML =
        "<div class='copy-clipboard__notch copy-clipboard__window'></div>Copied";

      wrapper.appendChild(button);
      wrapper.appendChild(popover);

      element.addEventListener("mousedown", function(e) {
        //clear
        window.getSelection().removeAllRanges();
        //Remove existing selected box
        if (document.querySelector(".copy-clipboard__selected")) {
          document.querySelector(".copy-clipboard__selected").remove();
        }
        if (document.querySelector(".copy-clipboard__popover.active")) {
          document
            .querySelector(".copy-clipboard__popover.active")
            .classList.remove("active");
        }
      });

      element.addEventListener("mouseup", function(e) {
        var selectedText = document
          .getSelection()
          .toString()
          .trim();

        if (selectedText.length > 0 && window.innerWidth > 980) {
          var popover = document.createElement("div");
          popover.className = "copy-clipboard__selected copy-clipboard__window";
          popover.innerHTML =
            '<span class="copy-clipboard__selected--copyBtn copy-clipboard__window">Copy</span>';
          popover.style.top = e.pageY + 5 + "px";
          popover.style.left = e.pageX + 5 + "px";

          //check right position and position reset inside viewport
          if (
            e.pageX + 255 >
            (window.innerWidth || document.documentElement.clientWidth)
          ) {
            var winWidth =
              window.innerWidth || document.documentElement.clientWidth;
            popover.style.left = winWidth - 255 + "px";
          }

          // Get element's bounding
          var bounding = popover.getBoundingClientRect();

          //check Top viewport
          if (checkSupportsSmoothScroll() && bounding.top < 0) {
            window.scrollTo({
              top: e.pageY + window.innerHeight + 55,
              behavior: "smooth"
            });
          }

          //check Bottom viewport
          if (
            checkSupportsSmoothScroll() &&
            e.clientY + 55 >
              (window.innerHeight || document.documentElement.clientHeight)
          ) {
            window.scrollTo({
              top: e.pageY - window.innerHeight + 55,
              behavior: "smooth"
            });
          }

          popover.addEventListener(
            "click",
            function(evt) {
              evt.preventDefault();
              if (popover.classList.contains("active")) {
                return;
              }
              //Copy Command
              if (document.getElementById("popoverSelectedCopyTextArea")) {
                var el = document.getElementById("popoverSelectedCopyTextArea");
                el.value = selectedText;
                el.style.top = e.pageY + 5 + "px";
              } else {
                var el = document.createElement("textarea");
                el.id = "popoverSelectedCopyTextArea";
                el.value = selectedText;
                el.setAttribute("readonly", "readonly");
                el.style.cssText =
                  "position:absolute; left:-9999px; width: 1px; height: 1px; border: 0;";
                el.style.top = e.pageY + 5 + "px";
                document.body.appendChild(el);
              }
              el.select();
              document.execCommand("copy");

              //WebTracker Event
              WebEventTracker.logEvent("", "OnClickCodeSnippetCopy", {
                property: "SelectiveCode",
                keyboard: popover.hasAttribute("data-keyboard") ? 1 : 0
              });

              popover.classList.add("active");
              popover.innerHTML = "Copied";

              // Check popover is visiable in viewport
              // Get element's bounding
              var bounding = popover.getBoundingClientRect();

              //check Top viewport
              if (checkSupportsSmoothScroll() && bounding.top < 0) {
                window.scrollTo({
                  top: e.pageY + window.innerHeight + popover.offsetHeight + 21,
                  behavior: "smooth"
                });
              }

              //check Bottom viewport
              if (
                checkSupportsSmoothScroll() &&
                bounding.bottom >
                  (window.innerHeight || document.documentElement.clientHeight)
              ) {
                window.scrollTo({
                  top: e.pageY - window.innerHeight + popover.offsetHeight + 21,
                  behavior: "smooth"
                });
              }
            },
            false
          );

          document.body.appendChild(popover);
        }
      });

      //With Keyboard register the handler
      element.addEventListener("keydown", function(evt) {
        // Ctrl+C or Cmd+C
        if ((evt.ctrlKey || evt.metaKey) && evt.keyCode == 67) {
          var clipboardSelected = document.querySelector(
            ".copy-clipboard__selected"
          );
          if (clipboardSelected) {
            clipboardSelected.dataset.keyboard = 1;
            clipboardSelected.click();
          }
        }
      });
    }

    /*
     * Popover click copy to clipboard functionality
     * Showing popover success infor with CTA
     */
    var clipboardBtn = document.querySelectorAll(".copy-clipboard__btn");
    for (var i = 0; i < clipboardBtn.length; i++) {
      clipboardBtn[i].addEventListener(
        "click",
        function(evt) {
          evt.preventDefault();
          if (document.querySelector(".copy-clipboard__selected")) {
            document.querySelector(".copy-clipboard__selected").remove();
          }

          //Copy Code
          var node = this.parentNode.querySelectorAll("pre.prettyprint")[0],
            selected = false;

          if (document.body.createTextRange) {
            var range = document.body.createTextRange();
            range.moveToElementText(node);
            range.select();
            selected = true;
          } else if (window.getSelection) {
            var selection = window.getSelection();
            var range = document.createRange();
            range.selectNodeContents(node);
            selection.removeAllRanges();
            selection.addRange(range);
            selected = true;
          } else {
            console.warn("Could not select text in node: Unsupported browser.");
          }

          if (selected) {
            document.execCommand("copy");
          }

          //WebTracker Event
          WebEventTracker.logEvent("", "OnClickCodeSnippetCopy", {
            property: "FullCode"
          });

          //remove class
          var clipboardPopover = document.querySelectorAll(
            ".copy-clipboard__popover"
          );
          for (var j = 0; j < clipboardPopover.length; j++) {
            clipboardPopover[j].classList.remove("active");
          }
          var popover = this.parentNode.getElementsByClassName(
            "copy-clipboard__popover"
          )[0];
          popover.classList.add("active");

          // Check popover is visiable in viewport
          // Get element's bounding
          var bounding = popover.getBoundingClientRect();

          //check Top viewport
          if (checkSupportsSmoothScroll() && bounding.top < 84) {
            window.scrollTo({
              top: evt.pageY - popover.offsetHeight - 120,
              behavior: "smooth"
            });
          }

          //check Bottom viewport
          if (
            checkSupportsSmoothScroll() &&
            bounding.bottom >
              (window.innerHeight || document.documentElement.clientHeight)
          ) {
            window.scrollTo({
              top:
                evt.pageY -
                window.innerHeight +
                (window.innerWidth > 1342
                  ? popover.offsetHeight / 2 + 21
                  : popover.offsetHeight + 42),
              behavior: "smooth"
            });
          }
        },
        false
      );
    }

    /*
     * When the user clicks anywhere outside of the modal, close it
     */
    window.addEventListener(
      "click",
      function(event) {
        if (!event.target.classList.contains("copy-clipboard__window")) {
          if (document.querySelector(".copy-clipboard__popover.active")) {
            document
              .querySelector(".copy-clipboard__popover.active")
              .classList.remove("active");
          }
          if (
            event.target.getParents(".prettyprint__wrapper").length == 0 &&
            document.querySelector(".copy-clipboard__selected")
          ) {
            document.querySelector(".copy-clipboard__selected").remove();
          }
          var elTextArea = document.getElementById(
            "popoverSelectedCopyTextArea"
          );
          if (elTextArea) {
            elTextArea.remove();
          }
        }
      },
      false
    );
  }

  function checkSupportsSmoothScroll() {
    var supports = false;
    try {
      var div = document.createElement("div");
      div.scrollTo({
        top: 0,
        get behavior() {
          supports = true;
          return "smooth";
        }
      });
    } catch (err) {}
    return supports;
  }

  function getParentsElem() {
    //Matches Polyfill
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        function(s) {
          var matches = (this.document || this.ownerDocument).querySelectorAll(
              s
            ),
            i = matches.length;
          while (--i >= 0 && matches.item(i) !== this) {}
          return i > -1;
        };
    }
    /*
     * Get Parents element of selector node
     * return Array
     */
    Element.prototype.getParents = function(selector) {
      var elements = [];
      var elem = this;
      var ishaveselector = selector !== undefined;

      while ((elem = elem.parentElement) !== null) {
        if (elem.nodeType !== Node.ELEMENT_NODE) {
          continue;
        }

        if (!ishaveselector || elem.matches(selector)) {
          elements.push(elem);
        }
      }

      return elements;
    };
  }
  /*
   * CTA On Click Events
   */
  function onClickCTAEvent(bool) {
    //As per bool variable its set property
    var props = bool ? "FullCode" : "SelectiveCode";

    //WebTracker Event
    WebEventTracker.logEvent("", "OnClickCodeSnippetCTA", {
      property: props
    });
  }
})();

codeSnippetFunc.init();
